import React, { useState, useRef } from "react";
import { FiCalendar, FiX } from "react-icons/fi";
import "./BusinessDetailsModal.css";

const DateInput = ({ label, value, onChange, name }) => {
  const inputRef = useRef(null);
  return (
    <div className="bdm-date-field">
      <label>{label}</label>
      <div className="bdm-date-box">
        <FiCalendar className="bdm-cal-icon" />
        <span className={value ? "date-val" : "date-placeholder"}>
          {value
            ? new Date(value).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })
            : "Select date"}
        </span>
        <input
          ref={inputRef}
          type="date"
          name={name}
          value={value || ""}
          onChange={(e) => onChange(name, e.target.value)}
          className="hidden-date-input"
        />
      </div>
    </div>
  );
};

const BusinessDetailsModal = ({ userData, onClose, onSave, loading }) => {
  const [form, setForm] = useState({
    name: userData?.name || "",
    email: userData?.email || "",
    phone: userData?.phone || "",
    postCode: userData?.postCode || "",
    registrationNo: userData?.registrationNo || "",
    vatNo: userData?.vatNo || "",
    website: userData?.website || userData?.websiteUrl || "",
    address: userData?.address || "",
    incorpDate: userData?.incorpDate || "",
    financialYearStart: userData?.financialYearStart || "",
    financialYearEnd: userData?.financialYearEnd || "",
    taxStartDate: userData?.taxStartDate || "",
  });

  const handleChange = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = () => {
    onSave(form);
  };

  return (
    <div className="bdm-overlay" onClick={onClose}>
      <div className="bdm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="bdm-header">
          <h2>Edit Business Details</h2>
          <button className="bdm-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>

        <div className="bdm-body">
          <div className="bdm-grid">
            {[
              { label: "Business Name", field: "name", type: "text" },
              { label: "Email", field: "email", type: "email" },
              { label: "Phone", field: "phone", type: "tel" },
              { label: "Post Code", field: "postCode", type: "text" },
              {
                label: "Registration No.",
                field: "registrationNo",
                type: "text",
              },
              { label: "VAT Number", field: "vatNo", type: "text" },
              { label: "Website", field: "website", type: "url" },
              { label: "Address", field: "address", type: "text" },
            ].map(({ label, field, type }) => (
              <div key={field} className="bdm-field">
                <label>{label}</label>
                <input
                  type={type}
                  value={form[field]}
                  placeholder={`Enter ${label.toLowerCase()}`}
                  onChange={(e) => handleChange(field, e.target.value)}
                />
              </div>
            ))}
          </div>

          <div className="bdm-section-title">Financial Year</div>
          <div className="bdm-date-row">
            <DateInput
              label="Financial Year Start"
              name="financialYearStart"
              value={form.financialYearStart}
              onChange={handleChange}
            />
            <DateInput
              label="Financial Year End"
              name="financialYearEnd"
              value={form.financialYearEnd}
              onChange={handleChange}
            />
            <DateInput
              label="Tax Start Date"
              name="taxStartDate"
              value={form.taxStartDate}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="bdm-footer">
          <button className="btn-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="btn-save" onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessDetailsModal;
